var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            direction: "rtl",
            size: "50%",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.drawer
            ? _c(
                "el-form",
                {
                  ref: "form",
                  staticStyle: { padding: "16px" },
                  attrs: {
                    "label-position": "top",
                    model: _vm.form,
                    disabled: _vm.openType == "view",
                    rules: _vm.rules,
                    "label-width": "160px",
                  },
                },
                [
                  _c("BjDivider", [
                    _vm._v(
                      _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Basic")) +
                        " "
                    ),
                  ]),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.searchName"),
                                prop: "chargeItemCode",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", clearable: false },
                                model: {
                                  value: _vm.form.chargeItemCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "chargeItemCode", $$v)
                                  },
                                  expression: "form.chargeItemCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.startDate"),
                                prop: "startDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  format: "dd/MM/yyyy",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: _vm.$t("billingPage.startDate"),
                                },
                                model: {
                                  value: _vm.form.startDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "startDate", $$v)
                                  },
                                  expression: "form.startDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "BjDivider",
                    { attrs: { "right-fixed": "" } },
                    [
                      _vm._v(_vm._s(_vm.$t("billingPage.historicalBB")) + " "),
                      _c(
                        "template",
                        { slot: "right" },
                        [
                          _vm.form.position2b.length == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.addPositionB },
                                },
                                [_vm._v(_vm._s(_vm.$t("addText")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.hisGeneral"),
                                prop: "costPrice2b",
                              },
                            },
                            [
                              _c(
                                "BjInputNumber",
                                {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.costPrice2b,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "costPrice2b", $$v)
                                    },
                                    expression: "form.costPrice2b",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("$"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.hisTime"),
                                prop: "costMinute2b",
                              },
                            },
                            [
                              _c(
                                "BjInputNumber",
                                {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.costMinute2b,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "costMinute2b", $$v)
                                    },
                                    expression: "form.costMinute2b",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("Mins"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.form.position2b, function (positionB, index) {
                    return _c(
                      "el-row",
                      { key: index },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("billingPage.position") +
                                    (index + 1),
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: { "option-list": _vm.departList },
                                  model: {
                                    value: _vm.form.position2b[index]["name"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.position2b[index],
                                        "name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.position2b[index]['name']",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                key: positionB.key,
                                attrs: {
                                  label:
                                    _vm.$t("billingPage.hisPerce") +
                                    (index + 1),
                                  prop: "position2b." + index + ".percentage",
                                  rules: {
                                    required: true,
                                    message: _vm.$t("inputText"),
                                    trigger: "blur",
                                  },
                                },
                              },
                              [
                                _c(
                                  "BjInputNumber",
                                  {
                                    model: {
                                      value: positionB.percentage,
                                      callback: function ($$v) {
                                        _vm.$set(positionB, "percentage", $$v)
                                      },
                                      expression: "positionB.percentage",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "28px",
                              "font-size": "25px",
                              color: "seagreen",
                            },
                            attrs: { span: 4 },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-remove-outline",
                              on: {
                                click: function ($event) {
                                  return _vm.removePositionB(index)
                                },
                              },
                            }),
                            _c("i", {
                              staticClass: "el-icon-circle-plus-outline",
                              staticStyle: { "margin-left": "18px" },
                              on: {
                                click: function ($event) {
                                  return _vm.addPositionB()
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "BjDivider",
                    { attrs: { "right-fixed": "" } },
                    [
                      _vm._v(_vm._s(_vm.$t("billingPage.historicalCC")) + " "),
                      _c(
                        "template",
                        { slot: "right" },
                        [
                          _vm.form.position2c.length == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.addPositionC },
                                },
                                [_vm._v(_vm._s(_vm.$t("addText")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.hisGeneral"),
                                prop: "costPrice2c",
                              },
                            },
                            [
                              _c(
                                "BjInputNumber",
                                {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.costPrice2c,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "costPrice2c", $$v)
                                    },
                                    expression: "form.costPrice2c",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.hisTime"),
                                prop: "costMinute2c",
                              },
                            },
                            [
                              _c(
                                "BjInputNumber",
                                {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.costMinute2c,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "costMinute2c", $$v)
                                    },
                                    expression: "form.costMinute2c",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("Mins"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.form.position2c, function (positionC, index) {
                    return _c(
                      "el-row",
                      { key: index },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("billingPage.position") +
                                    (index + 1),
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: { "option-list": _vm.departList },
                                  model: {
                                    value: _vm.form.position2c[index]["name"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.position2c[index],
                                        "name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.position2c[index]['name']",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                key: positionC.key,
                                attrs: {
                                  label:
                                    _vm.$t("billingPage.hisPerce") +
                                    (index + 1),
                                  prop: "position2c." + index + ".percentage",
                                  rules: {
                                    required: true,
                                    message: _vm.$t("inputText"),
                                    trigger: "blur",
                                  },
                                },
                              },
                              [
                                _c(
                                  "BjInputNumber",
                                  {
                                    model: {
                                      value: positionC.percentage,
                                      callback: function ($$v) {
                                        _vm.$set(positionC, "percentage", $$v)
                                      },
                                      expression: "positionC.percentage",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "28px",
                              "font-size": "25px",
                              color: "seagreen",
                            },
                            attrs: { span: 4 },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-remove-outline",
                              on: {
                                click: function ($event) {
                                  return _vm.removePositionC()
                                },
                              },
                            }),
                            _c("i", {
                              staticClass: "el-icon-circle-plus-outline",
                              staticStyle: { "margin-left": "18px" },
                              on: {
                                click: function ($event) {
                                  return _vm.addPositionC()
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "foot" },
            [
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.openType == "view" },
                  on: { click: _vm.onComfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }